/**************************************************
 * Nombre:       Home_Oferta_Tiempo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import fondo from "../../../Recursos/fondo_oferta.svg";
import Tarjeta_Oferta_Tiempo from "../../Tarjetas/Tarjeta_Oferta_Tiempo";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Home_Oferta_Tiempo = () => {
    const [ofertas, setOfertas] = useState([]);

    useEffect(() => {

        let fecha = new Date().setHours(0)

        let w = [where('fechaOferta', '>=', fecha), where('oferta', '==', true)];
        obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
            if (dox.res) {
                setOfertas(dox.data);
            }
        })


    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'center'}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: false,
                        pagination: false,
                        width: '100%',
                        drag: 'false',
                        interval: 8000,
                        noDrag: true,
                        type: 'fade',


                    }}
                >

                    {ofertas.map((it, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <Tarjeta_Oferta_Tiempo item={it}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>


            </Grid>

        </Grid>
    )

}
export default Home_Oferta_Tiempo
